import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a559921e")

_pushScopeId("data-v-a559921e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-md-9" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { class: "p-d-flex p-ai-center" }
const _hoisted_5 = { class: "p-pl-2" }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-pl-2" }
const _hoisted_8 = {
  key: 0,
  class: "p-pl-2"
}
const _hoisted_9 = {
  class: "pi pi-info-circle p-ml-1",
  style: {"vertical-align":"middle"}
}
const _hoisted_10 = {
  key: 1,
  class: "p-error"
}
const _hoisted_11 = { class: "p-d-none p-d-md-block p-col-12 p-md-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataTable, {
        scrollHeight: "60vh",
        value: _ctx.listPreviewData,
        showGridlines: "",
        selection: _ctx.selectHeader,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectHeader = $event)),
        selectionMode: "single",
        dataKey: "columns",
        onRowSelect: _ctx.onRowClick,
        style: {"height":"60vh"},
        responsiveLayout: "scroll"
      }, {
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "columns",
            header: _ctx.$t('upload.datasource.column.name')
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "dataType",
            header: _ctx.$t('upload.datasource.data.type')
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Dropdown, {
                  modelValue: slotProps.data.dataType,
                  "onUpdate:modelValue": ($event: any) => (slotProps.data.dataType = $event),
                  options: _ctx.listDataType(slotProps.data.originalDataType),
                  onChange: ($event: any) => (
                  _ctx.onDataTypeChange(slotProps.data.dataType, slotProps.index)
                ),
                  optionLabel: "name",
                  optionValue: "code",
                  placeholder: _ctx.$t('upload.datasource.select.data.type')
                }, {
                  value: _withId((slotProps) => [
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_DataType, {
                        dataType: slotProps.value
                      }, null, 8, ["dataType"]),
                      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.value}`)), 1)
                    ])
                  ]),
                  option: _withId((slotProps) => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_DataType, {
                        dataType: slotProps.option.code
                      }, null, 8, ["dataType"]),
                      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.option.code}`)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange", "placeholder"]),
                (_ctx.checkIfHasIdInName(slotProps.data.columns))
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _withDirectives(_createVNode("i", _hoisted_9, null, 512), [
                        [_directive_tooltip, 
                    _ctx.$t('upload.datasource.header.column.has.id', {
                      suffix: _ctx.checkIfHasIdInName(slotProps.data.columns),
                    })
                  ]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "role",
            header: _ctx.$t('upload.datasource.data.role'),
            style: {"min-width":"10rem"}
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_DataRole, {
                role: slotProps.data.role
              }, null, 8, ["role"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "format",
            header: _ctx.$t('upload.datasource.format')
          }, {
            body: _withId((slotProps) => [
              (slotProps.data.dataType == 'date')
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    modelValue: slotProps.data.format,
                    "onUpdate:modelValue": ($event: any) => (slotProps.data.format = $event),
                    options: _ctx.typeDate,
                    onChange: ($event: any) => (
                _ctx.onChangeDateFormat(slotProps.data.format, slotProps.index)
              ),
                    optionLabel: "code",
                    optionValue: "code",
                    placeholder: _ctx.$t('upload.datasource.select.date.format.type'),
                    editable: true,
                    filter: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "placeholder"]))
                : _createCommentVNode("", true),
              (_ctx.hasNullValue(slotProps.data))
                ? (_openBlock(), _createBlock("div", _hoisted_10, " *" + _toDisplayString(_ctx.$t("datasource.null.value.found")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "selection", "onRowSelect"])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_DataTable, {
        scrollable: true,
        scrollHeight: "60vh",
        value: _ctx.listValuePreviewData,
        class: "p-datatable-sm",
        showGridlines: "",
        responsiveLayout: "scroll",
        style: {"height":"60vh"}
      }, {
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "value",
            header: _ctx.previewDataLable
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
})